// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"245":"7b6d0d90","447":"0c2a6b99","587":"0c2a6b99","713":"b69d1979","964":"0c2a6b99"}[chunkId] + ".chunk.css";
};